import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { c as cx } from './index-tZvMCc77.js';
import { I as Icon } from './Icon-BBWg60pO-Dja0R43O.js';
import { s as styles } from './Button.module-CDPD2nx9-CDPD2nx9.js';
import { S as Spinner } from './Spinner-B55mSnmk-B3oOSVLo.js';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

const Button = forwardRef(
  (props, ref) => {
    const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
    const {
      children,
      className,
      appearance = "secondary",
      size = "medium",
      icon,
      loading = false,
      disabled,
      style,
      type = "button",
      ...rest
    } = componentProps;
    const buttonClassNames = cx(className, styles["button"], {
      [styles["appearance-primary"]]: appearance === "primary",
      [styles["appearance-secondary"]]: appearance === "secondary",
      [styles["appearance-ghost"]]: appearance === "ghost",
      [styles["danger-secondary"]]: appearance === "danger-secondary",
      [styles["danger-primary"]]: appearance === "danger",
      [styles["size-small"]]: size === "small",
      [styles["size-medium"]]: size === "medium",
      [styles["size-large"]]: size === "large",
      [styles["type-icon"]]: !children,
      [styles["loading"]]: loading
    });
    const iconBefore = (icon2) => {
      if (typeof icon2 === "object" && "before" in icon2) {
        return /* @__PURE__ */ jsx(
          Icon,
          {
            className: styles["icon"],
            inherit: true,
            "aria-hidden": true,
            svg: icon2.before
          }
        );
      }
      if (icon2 && typeof icon2 !== "object") {
        return /* @__PURE__ */ jsx(
          Icon,
          {
            className: styles["icon"],
            inherit: true,
            "aria-hidden": true,
            svg: icon2,
            size: !children && size !== "small" ? "large" : "medium"
          }
        );
      }
      return;
    };
    const styleCombined = {
      ...style,
      ...layoutStyles
    };
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: buttonClassNames,
        type,
        disabled: disabled || loading,
        "aria-busy": loading ? true : void 0,
        "data-anv": "button",
        style: styleCombined,
        ref,
        ...rest,
        children: [
          loading ? /* @__PURE__ */ jsx(Spinner, { inherit: true, className: styles["loading-spinner"] }) : icon ? iconBefore(icon) : null,
          children,
          typeof icon === "object" && "after" in icon ? /* @__PURE__ */ jsx(
            Icon,
            {
              className: styles["icon"],
              inherit: true,
              "aria-hidden": true,
              svg: icon.after
            }
          ) : null
        ]
      }
    );
  }
);
Button.displayName = "Button";

export { Button as B };
//# sourceMappingURL=Button-DbVpPjA8-CRQ01IJx.js.map
